module.exports = __webpack_public_path__ + "static/media/kawaii-jump.2af160c2.jpg";